<pay-dialog-title [innerHTML]="config.title | translate: config.titleParams"></pay-dialog-title>
<pay-dialog-body>
    <button payIconButton icon="close" class="c-icon-btn--sm x-close-confirm-dialog-icon-button" payDialogClose></button>
    <div [innerHTML]="config.content | translate: config.contentParams"></div>
    <div class="text-left" *ngIf="config.items && config.items.length">
        <hr>
        <ul class="list-unstyled">
            <li *ngFor="let item of config.items">
                <div class="pay-circle-danger">
                    <i class="icon-close"></i>
                </div>
                <span [innerHTML]="item | translate"></span>
            </li>
        </ul>
        <hr>
    </div>
    <div *ngIf="config?.optionalMessage" class="mt-4">
        <textarea class="c-form-control c-dialog__optional-message"
                  placeholder="{{ 'Common.OptionalMessage' | translate }}"
                  payAutoFocus
                  [(ngModel)]="optionalMessage" rows="2"
                  maxlength="{{ config?.optionalMessageMaxLength > 0 ? config?.optionalMessageMaxLength : null }}"></textarea>
        <div *ngIf="config?.optionalMessageMaxLength > 0" class="mt-2 d-flex justify-content-end">
            <span
                class="c-label--muted">{{ 'Common.MaxCharacters' | translate: {count: config?.optionalMessageMaxLength} }}</span>
        </div>
    </div>
</pay-dialog-body>
<pay-dialog-actions>
    <pay-button-group class="ml-auto c-btn-group--gap-2">
        <button payButton type="button"
                class="c-btn--secondary"
                payDialogClose
                *ngIf="!config?.hideCancelButton"
                [disabled]="isClosing">
            {{ cancelText | translate }}
        </button>
        <button payButton type="button"
                class="{{confirmBtnModifierClass}}"
                [disabled]="isClosing"
                [payDialogClose]="config?.optionalMessage ? { confirmed: true, message: optionalMessage } : true">
            {{ confirmText | translate }}
        </button>
    </pay-button-group>
</pay-dialog-actions>
